/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/interactive-supports-focus */
import React from 'react';
import PropTypes from 'prop-types';
import {
  toggleAccordion,
  closeAccordion,
} from '@/utils/Controllers/AccordionController';
import { useTranslation } from 'react-i18next';
import { useStoreFinderContext } from '@/storeFinder/context';
import {
  MAX_DISTANCE,
  getFiltersSelected,
} from '@/storeFinder/context/selectors';
import { isDelonghi } from '@/utils/Common/Booleans';

// components
import RadioButton from '@/components/atoms/RadioButton';
import Checkbox from '@/components/atoms/Checkbox';

const AccordionFilter = ({ distances, services }) => {
  const { t } = useTranslation();
  const [
    { currentService, currentDistance, pos, searched },
    {
      setSearch,
      setService,
      setCurrentDistance,
      setCurrentService,
      unsetCurrentService,
      resetCurrentService,
    },
  ] = useStoreFinderContext();

  const filtersSelected = getFiltersSelected(currentDistance, currentService);

  const handleReset = e => {
    e.stopPropagation();
    setService(
      services.map(type => ({
        ...type,
        isChecked: false,
      })),
    );
    resetCurrentService();
    setSearch({
      currentDistance: MAX_DISTANCE,
      searched: '',
    });
    closeAccordion('filters');
  };

  const handleTypeChange = event => {
    setService(
      services.map(type =>
        type.value === event.target.value
          ? { ...type, isChecked: event.target.checked }
          : type,
      ),
    );
    if (event.target.checked) setCurrentService(event.target.value);
    else unsetCurrentService(event.target.value);
  };

  const handleDistance = event => {
    setCurrentDistance(event.target.value);
  };

  return (
    <>
      <div
        className='dln-accordion dln-accordion--titleIcon dln-accordion--ui-03 dln-accordion--filter dln-accordion--filters-active'
        id='filters'
      >
        <button
          className='dln-accordion__head'
          onClick={e => toggleAccordion(e)}
          type='button'
        >
          <i className='dln-accordion__icon dln-icn dln-icn--iconfont dln-icn--f'>
            f
          </i>
          <span className='dln-accordion__title'>
            {t('storeFinder:store.finder.filter.label')}
            {filtersSelected > 0 && <span>&nbsp;({filtersSelected})</span>}
          </span>
          <i className='dln-icn dln-icn--iconfont dln-icn--arrow-down dln-icn--u'>
            u
          </i>
        </button>
        {filtersSelected > 0 && (
          <button
            className='dln-btn dln-btn--link dln-btn--reset dln-outline'
            type='button'
            title='Reset'
            onClick={handleReset}
          >
            <span className='dln-btn__lbl'>
              {t('storeFinder:store.finder.reset')}
            </span>
          </button>
        )}
        <div className='dln-accordion__content'>
          <div className='dln-accordion__wrap'>
            <h2 className='dln-accordion__wrapTitle'>
              {t('storeFinder:store.finder.filter.distance')}
            </h2>
            {distances.map(distance => (
              <RadioButton
                key={`distance--${distance}`}
                label={`${distance} ${
                  DLG.gigya.country === 'US' && DLG.config.brand === 'delonghi'
                    ? 'Mi'
                    : 'Km'
                }`}
                onChange={handleDistance}
                id={`distance-${distance}`}
                name='distance'
                value={distance}
                isChecked={
                  parseInt(currentDistance, 10) === parseInt(distance, 10)
                }
              />
            ))}
          </div>
          {isDelonghi && services.length > 0 && (
            <div className='dln-accordion__wrap'>
              <h2 className='dln-accordion__wrapTitle'>
                {t('storeFinder:store.finder.filter.type')}
              </h2>
              {services.map(type => (
                <Checkbox
                  key={`type--${type.value}`}
                  label={type.name}
                  onChange={handleTypeChange}
                  id={`type-${type.value}`}
                  name={`type-${type.value}`}
                  value={type.value}
                  checked={currentService.indexOf(type.value) > -1}
                />
              ))}
            </div>
          )}
        </div>
      </div>
      {searched !== '' && (
        <p className='dln-serviceLocator__resultCounter'>
          {t('storeFinder:store.finder.results', {
            results: currentDistance === MAX_DISTANCE ? 0 : pos.length,
          })}
        </p>
      )}
    </>
  );
};

AccordionFilter.propTypes = {
  distances: PropTypes.arrayOf(PropTypes.string).isRequired,
  services: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default AccordionFilter;
